export class CompanyIncomeStatement {
    constructor(current, previous, rows) {
        this.currentYear = current.year;
        this.currentMonth = current.month;
        this.previousYear = previous.year;
        this.previousMonth = previous.month;
        this.rows = rows;
    }
}